import { useState, useEffect, useContext } from "react";
import "./App.css";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Social from "./pages/Social";
import Threelogin from "./pages/Threelogin";
import Loginpage from "./pages/LoginPage";
import UserDetailsVerify from "./pages/Userdetails";
import Inference from "./pages/Inference";
import Search from "./pages/Search";
import { NavBottom, SideDrawer } from "./components/Nav";
import Chats from "./components/Chats";
import NewPost from "./components/NewPost";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import Loader from "./components/Loader";
import { SessionContext } from "./SessionContext";
import supabase from "./utils/supabase";
import Settings from "./pages/Settings";
import Profile from "./pages/Profile";
import { ProtectedRoute } from "./components/ProtectedRoute";
import PublicProfile from "./pages/PublicProfile";
import Chatting from "./pages/Chatting";
import { ChatProvider } from "./context/ChatContext";
import useUserStore from "./store/userStore";

function App() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState(null);
  const setUserData = useUserStore((state) => state.setUserData);
  const clearUserData = useUserStore((state) => state.clearUserData);

  const showNav = !["/signin", "/signup"].includes(location.pathname);

  useEffect(() => {
    // Get initial session
    supabase.auth.getSession().then(({ data: { session: initialSession } }) => {
      setSession(initialSession);
      if (initialSession?.user) {
        supabase
          .from("users")
          .select("*")
          .eq("id", initialSession.user.id)
          .single()
          .then(({ data }) => {
            if (data) setUserData(data);
            setLoading(false);
          });
      } else {
        setLoading(false);
      }
    });

    // Listen for auth changes
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      if (session?.user) {
        supabase
          .from("users")
          .select("*")
          .eq("id", session.user.id)
          .single()
          .then(({ data }) => {
            if (data) setUserData(data);
          });
      } else {
        clearUserData();
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  // Add timeout for loading state
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (loading) {
        console.warn("Loading timeout reached");
        setLoading(false);
      }
    }, 5000);

    return () => clearTimeout(timeout);
  }, [loading]);

  if (loading) {
    return <Loader loading={true} />;
  }

  return (
    <div className="App">
      <SessionContext.Provider value={session}>
        <ChatProvider>
          {showNav && <SideDrawer />}
          <div className={`${showNav ? "lg:ml-[250px]" : ""}`}>
            <Routes>
              {/* Public Routes */}
              <Route
                path="/signin"
                element={
                  !session ? <SignIn /> : <Navigate to="/social" replace />
                }
              />
              <Route
                path="/signup"
                element={
                  !session ? <SignUp /> : <Navigate to="/social" replace />
                }
              />

              {/* Protected Routes */}
              <Route element={<ProtectedRoute />}>
                <Route path="/social" element={<Social />} />
                <Route path="/chat/:id" element={<Chatting />} />
                <Route path="/chats" element={<Chats />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/profile/:userId" element={<PublicProfile />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/search" element={<Search />} />
                <Route path="/newPost" element={<NewPost />} />
                <Route path="/inference" element={<Inference />} />
                <Route path="/signup/preference" element={<Threelogin />} />
                <Route
                  path="/userdetailsverify"
                  element={<UserDetailsVerify />}
                />
                <Route path="/" element={<Navigate to="/social" replace />} />
                <Route path="*" element={<Navigate to="/social" replace />} />
              </Route>
            </Routes>
          </div>
          {showNav && <NavBottom />}
        </ChatProvider>
      </SessionContext.Provider>
    </div>
  );
}

export default App;
